import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { server } from "..";
import Loader from "./Loader";
import ToolWorkspace from "../components/ToolWorkspace";

const Paraphrasing = () => {
  const [inputText, setInputText] = useState("");
  const [output, setOutput] = useState("");
  const [disable, setDisable] = useState(false);
  const [loader, setLoader] = useState(false);

  const handlesubmit = async () => {
    if (!inputText || inputText.length <= 20) {
      toast.error("Too short");
      return;
    }

    setDisable(true);
    setLoader(true);
    try {
      const { data } = await axios.post(
        `${server}/tools/gram`,
        { name: inputText },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      toast.success("Done!");
      setOutput(data.trying);
    } catch {
      toast.error("Error occured, try again");
    } finally {
      setDisable(false);
      setLoader(false);
    }
  };

  return (
    <ToolWorkspace
      label="Writing"
      title="Grammar / Spell Check"
      subtitle="Paste your text and get a clearer, polished version back."
    >
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="flex flex-col gap-3">
          <label className="font-display text-sm font-semibold text-brand-forest">
            Your text
          </label>
          <textarea
            onChange={(e) => setInputText(e.target.value)}
            className="min-h-[280px] w-full resize-y rounded-xl border border-brand-forest/12 bg-white px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none transition placeholder:text-brand-muted/55 focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/20"
            placeholder="Paste at least a few sentences to check..."
            value={inputText}
          />
          <button
            type="button"
            onClick={handlesubmit}
            disabled={disable}
            className="btn w-full disabled:cursor-not-allowed disabled:opacity-70"
          >
            {disable ? "Working..." : "Get text"}
          </button>
        </div>

        <div className="flex flex-col gap-3">
          <label className="font-display text-sm font-semibold text-brand-forest">
            Result
          </label>
          {loader ? (
            <div className="flex min-h-[280px] w-full items-center justify-center rounded-xl border border-brand-forest/10 bg-brand-surface">
              <Loader />
            </div>
          ) : (
            <textarea
              disabled
              className="min-h-[280px] w-full resize-y rounded-xl border border-brand-forest/12 bg-brand-surface/50 px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none placeholder:text-brand-muted/55"
              placeholder="Paraphrased text will show here"
              value={output}
            />
          )}
        </div>
      </div>
    </ToolWorkspace>
  );
};

export default Paraphrasing;
